import { config } from 'src/constants';

export const staticBreadCrumbs = [
  {
    id: 'home',
    name: 'homePage',
    url: '/',
  },
  {
    id: 'account',
    name: 'accountPage',
    url: '/store/v2/accounts/dashboard',
  },
  {
    id: 'orders',
    name: 'ordersPage',
    url: '/order/catalog/en/US/partnerMkt/lt?cmd=WorkspaceDataDisplay&_Tab=Ordered#/',
  },
  {
    id: 'mcp',
    name: 'mcpPage',
    url: `${config.baseRoute}`,
  },
];
